var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-profil", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", { staticClass: "profileDashboard" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("menu-profil", {
                attrs: { profil: _vm.profil, spravy: _vm.spravy }
              }),
              _vm._v(" "),
              _vm.profil.pouzivatel_id
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-md-12 col-lg-8 col-xl-7" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _vm.responseText != ""
                        ? _c(
                            "div",
                            {
                              class: "alert alert-" + _vm.responseType,
                              attrs: { role: "alert" }
                            },
                            [
                              _c("span", {
                                class: "icon --" + _vm.responseType
                              }),
                              _vm._v(
                                _vm._s(_vm.responseText) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("form", { on: { submit: _vm.formSubmit } }, [
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mb-5" }, [
                          _c("div", { staticClass: "col-sm-6 mb-2 mb-md-0" }, [
                            _c("label", { staticClass: "form-label" }, [
                              _vm._v("Meno farmára")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.meno_farmara,
                                  expression: "meno_farmara"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: { value: _vm.meno_farmara },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.meno_farmara = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-6" }, [
                            _c("label", { staticClass: "form-label" }, [
                              _vm._v("Názov mliečnej farmy")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.nazov_farmy,
                                  expression: "nazov_farmy"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: { value: _vm.nazov_farmy },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.nazov_farmy = $event.target.value
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row mb-5" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _vm.farmar_skin_id == ""
                              ? _c(
                                  "div",
                                  { staticClass: "col-sm-3 text-center" },
                                  [_vm._m(2)]
                                )
                              : _vm._l(_vm.farmar_skiny, function(skin) {
                                  return _c(
                                    "div",
                                    { staticClass: "col-sm-3 text-center" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cow-wrapper dojicka mb-3 md-md-0"
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "check-container" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src:
                                                    "https://www.adoptujkravicku.sk/hra/dist/images/" +
                                                    skin.farmar_styl_img,
                                                  width: "60px",
                                                  height: "130px"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.farmar_skin_id,
                                                    expression: "farmar_skin_id"
                                                  }
                                                ],
                                                attrs: { type: "radio" },
                                                domProps: {
                                                  value: skin.id,
                                                  checked: _vm._q(
                                                    _vm.farmar_skin_id,
                                                    skin.id
                                                  )
                                                },
                                                on: {
                                                  change: function($event) {
                                                    _vm.farmar_skin_id = skin.id
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "checkmark"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("h3", [_vm._v("Vyberte si kravičku")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row mb-5" },
                          [
                            _vm.profil.pouzivatel_id &&
                            _vm.profil.pouzivatel_id.kravicky_pouzivatela
                              .length == 0
                              ? _c(
                                  "div",
                                  { staticClass: "col-sm-3 text-center" },
                                  [_vm._m(3)]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(
                              _vm.profil.pouzivatel_id.kravicky_pouzivatela,
                              function(kravicka) {
                                return _c(
                                  "div",
                                  { staticClass: "col-sm-3 text-center" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cow-wrapper mastal mb-3 md-md-0"
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "check-container" },
                                          [
                                            _c("img", {
                                              staticClass: "img-responsive",
                                              attrs: {
                                                src:
                                                  "https://www.adoptujkravicku.sk/data/foto/" +
                                                  kravicka.kravicka_img_hlava,
                                                width: "140px",
                                                height: "130px"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.kravicka_id,
                                                  expression: "kravicka_id"
                                                }
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: kravicka.id,
                                                checked: _vm._q(
                                                  _vm.kravicka_id,
                                                  kravicka.id
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.kravicka_id = kravicka.id
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div"),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "checkmark"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h2",
                                          { staticClass: "cow-name gamma" },
                                          [
                                            _vm._v(
                                              _vm._s(kravicka.kravicka_meno)
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row mb-5" },
                          [
                            _c("GmapMap", {
                              ref: "mapaVytvorenieFarmy",
                              staticStyle: { width: "100%", height: "270px" },
                              attrs: {
                                center: { lat: 48.707786, lng: 19.467559 },
                                zoom: 8,
                                options: {
                                  draggableCursor: "pointer",
                                  draggingCursor: "pointer",
                                  panControl: false,
                                  disableDefaultUI: true,
                                  mapTypeControl: false,
                                  draggable: true,
                                  zoomControl: true,
                                  styles: [
                                    {
                                      elementType: "geometry",
                                      stylers: [
                                        { hue: "#ff4400" },
                                        { saturation: -68 },
                                        { lightness: -4 },
                                        { gamma: 0.72 }
                                      ]
                                    },
                                    {
                                      featureType: "road",
                                      elementType: "labels.icon"
                                    },
                                    {
                                      featureType: "landscape.man_made",
                                      elementType: "geometry",
                                      stylers: [
                                        { hue: "#0077ff" },
                                        { gamma: 3.1 }
                                      ]
                                    },
                                    {
                                      featureType: "water",
                                      stylers: [
                                        { hue: "#00ccff" },
                                        { gamma: 0.44 },
                                        { saturation: -33 }
                                      ]
                                    },
                                    {
                                      featureType: "poi.park",
                                      stylers: [
                                        { hue: "#44ff00" },
                                        { saturation: -23 }
                                      ]
                                    },
                                    {
                                      featureType: "water",
                                      elementType: "labels.text.fill",
                                      stylers: [
                                        { hue: "#007fff" },
                                        { gamma: 0.77 },
                                        { saturation: 65 },
                                        { lightness: 99 }
                                      ]
                                    },
                                    {
                                      featureType: "water",
                                      elementType: "labels.text.stroke",
                                      stylers: [
                                        { gamma: 0.11 },
                                        { weight: 5.6 },
                                        { saturation: 99 },
                                        { hue: "#0091ff" },
                                        { lightness: -86 }
                                      ]
                                    },
                                    {
                                      featureType: "transit.line",
                                      elementType: "geometry",
                                      stylers: [
                                        { lightness: -48 },
                                        { hue: "#ff5e00" },
                                        { gamma: 1.2 },
                                        { saturation: -23 }
                                      ]
                                    },
                                    {
                                      featureType: "transit",
                                      elementType: "labels.text.stroke",
                                      stylers: [
                                        { saturation: -64 },
                                        { hue: "#ff9100" },
                                        { lightness: 16 },
                                        { gamma: 0.47 },
                                        { weight: 2.7 }
                                      ]
                                    }
                                  ]
                                }
                              },
                              on: { click: _vm.positionClick }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.lat,
                                  expression: "lat"
                                }
                              ],
                              attrs: { type: "hidden" },
                              domProps: { value: _vm.lat },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.lat = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.lng,
                                  expression: "lng"
                                }
                              ],
                              attrs: { type: "hidden" },
                              domProps: { value: _vm.lng },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.lng = $event.target.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.profil.pouzivatel_id &&
                        _vm.profil.id != 0 &&
                        _vm.profil.pouzivatel_id.farma_pouzivatela.length ==
                          0 &&
                        !_vm.isDisabled
                          ? _c("div", { staticClass: "row" }, [_vm._m(4)])
                          : _vm._e()
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "header d-flex align-items-center justify-content-between"
      },
      [_c("h2", [_vm._v("Vytvorte si mliečnu farmu")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("h3", { staticClass: "modal-title mb-2" }, [
        _vm._v("Vyberte si postavu")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cow-wrapper dojicka mb-3 md-md-0" }, [
      _c("label", { staticClass: "check-container" }, [
        _c("img", {
          staticStyle: { visibility: "hidden" },
          attrs: { src: "", width: "60px", height: "130px" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cow-wrapper mastal mb-3 md-md-0" }, [
      _c("label", { staticClass: "check-container" }, [
        _c("img", {
          staticStyle: { visibility: "hidden" },
          attrs: { src: "", width: "140px", height: "130px" }
        })
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "cow-name gamma" }, [_vm._v(" ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("button", { staticClass: "btn --primary" }, [
        _vm._v("VYTVORIŤ MLIEČNU FARMU")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }